import { Tabs } from "@asayinc/component-library";
import { Box } from "@mui/material";
import { Outlet, useMatch, useNavigate, useParams } from "react-router-dom";

import { BackLink } from "src/components/atoms/BackLink";
import { ErrorState } from "src/components/atoms/ErrorState";
import { PageContainer } from "src/components/containers/PageContainer/PageContainer";
import { EventPageHeader } from "src/components/molecules/EventPageHeader";
import { LoadingHeader } from "src/components/molecules/Loading/LoadingHeader";
import { SHARE_RANGE_ANALYSIS_LABEL } from "src/constants/labels/shareRangeAnalysisLabel";
import { SHARE_RANGE_ANALYSIS_EVENT_TABS } from "src/constants/tabs";
import { useShareRangeAnalysisEventQuery } from "src/store/shareRangeAnalysisEvent";

export function ShareRangeAnalysisEvent() {
  const navigate = useNavigate();
  const { id } = useParams() as { id: string };
  const {
    data: shareRangeAnalysisEvent,
    isLoading,
    error,
  } = useShareRangeAnalysisEventQuery({ id });
  const match = useMatch(`/share-range-analysis-events/${id}/:activeTab`) as {
    params: { activeTab: string };
  };

  const handleTabChange = (value: string) => {
    navigate(`/share-range-analysis-events/${id}/${value}`);
  };

  if (error || (!isLoading && !shareRangeAnalysisEvent)) {
    return <ErrorState />;
  }

  return (
    <PageContainer>
      <BackLink
        sx={{ mb: 3, ml: -2, pt: 10, px: 10 }}
        label="Share Range Analysis Events"
        to={`/reports/share-range-analysis-events?view=${
          shareRangeAnalysisEvent?.operationsStatus === "approved"
            ? "approved"
            : "upcoming"
        }`}
      />
      {isLoading ? (
        <LoadingHeader sx={{ px: 10 }} numberOfRows={1} />
      ) : (
        <EventPageHeader
          backLink={`/share-range-analysis-events/${id}/details`}
          issuerName={shareRangeAnalysisEvent.issuer.name || "-"}
          issuerId={shareRangeAnalysisEvent.issuer?.id}
          type={SHARE_RANGE_ANALYSIS_LABEL[shareRangeAnalysisEvent.type]}
          subHeader={
            shareRangeAnalysisEvent.jobNumber
              ? `${shareRangeAnalysisEvent.solicitor.name} - ${shareRangeAnalysisEvent.jobNumber}`
              : shareRangeAnalysisEvent.solicitor.name
          }
          sx={{ px: 10 }}
        />
      )}
      <Box sx={{ mx: 10, mt: 3 }}>
        <Tabs
          activeTab={match?.params?.activeTab || "details"}
          clickHandler={handleTabChange}
          tabs={SHARE_RANGE_ANALYSIS_EVENT_TABS}
        />
      </Box>
      <Outlet />
    </PageContainer>
  );
}
